import React, { useState } from 'react'
import { CBadge, CCard, CCardBody, CFormSwitch } from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import { InfoBox } from 'src/components/common/ImportWizard'

const PartnerVisibility = ({ showPosBased, setShowPosBased }) => {
  const [saving, setSaving] = useState(false)
  const isVisible = !!showPosBased

  const handleChangeStatus = (event) => {
    const checked = event.target.checked
    const nextValue = checked ? 1 : 0
    setShowPosBased(nextValue)
    setSaving(true)
    CommonService.updateShowBranding({ is_show: nextValue })
      .then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
        } else {
          setShowPosBased(nextValue ? 0 : 1)
          ToastComponent(res.message, 'error')
        }
      })
      .catch(() => {
        // Put the switch back where it was - the saved value did not change.
        setShowPosBased(nextValue ? 0 : 1)
        ToastComponent('Could not change the visibility.', 'error')
      })
      .finally(() => setSaving(false))
  }

  return (
    <CCard className="br-panel">
      <CCardBody>
        <div className="br-panel-toolbar">
          <div>
            <h2 className="br-panel-title">Fantasy Partner Visibility</h2>
            <p className="br-panel-note">Show or hide your branding on the fantasy partner tile.</p>
          </div>
          <CBadge
            color={isVisible ? 'success' : 'secondary'}
            shape="rounded-pill"
            className="px-3 py-2"
          >
            {isVisible ? 'Visible' : 'Hidden'}
          </CBadge>
        </div>

        <InfoBox color="info">
          When shown, members see your club logo and links as the fantasy partner. Saved as soon as
          you switch it.
        </InfoBox>

        <div className="br-setting">
          <div>
            <p className="br-setting-label">Show branding</p>
            <p className="br-setting-help">
              Turn this off to hide your branding from members without deleting it.
            </p>
          </div>
          <div className="br-setting-control">
            <CFormSwitch
              size="lg"
              label={isVisible ? 'On' : 'Off'}
              id="branding_show"
              checked={isVisible}
              disabled={saving}
              onChange={handleChangeStatus}
            />
          </div>
        </div>
      </CCardBody>
    </CCard>
  )
}

export default PartnerVisibility
